
import { Component, Vue } from 'vue-property-decorator';


@Component
export default class LanguageResources extends Vue {

	public navigateToGuide(){
        Vue.filter('scrollToLocation')("interpreter-guide");
    } 
}

